import axios from "axios";
import { mapState } from "vuex";

export const logoutRefreshMixin = {
  data() {
    return {
      currentHash: "{{POST_BUILD_ENTERS_HASH_HERE}}",
      hashChanged: false,
      newHash: ""
    };
  },
  computed: {
    ...mapState(["isLoggedIn", "buildHash"])
  },
  methods: {
    initVersionCheck(url, frequency = 1000 * 60 * 0.25) {
      if (!this.buildHash) {
        this.$store.commit("setBuildHash", this.currentHash);
      }

      setInterval(() => {
        this.checkVersion(url);
      }, frequency);
    },
    async checkVersion(url) {
      try {
        const fileResponse = await axios.get(
          `${url}?t=${new Date().getTime()}`
        );

        this.newHash = fileResponse.data.hash;

        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);
      } catch (error) {
        this.loading = false;
        if (!error.response) {
          this.errorStatus = "Error: Network Error";
        } else {
          this.errorStatus = error.response.data.message;
        }
      }
    },
    hasHashChanged(currentHash, newHash) {
      if (
        !currentHash ||
        currentHash === "{{POST_BUILD_ENTERS_HASH_HERE}}" ||
        this.buildHash !== currentHash
      ) {
        return true;
      }
      return currentHash !== newHash;
    },
    reloadApp() {
      this.currentHash = this.newHash;
      this.$store.commit("setBuildHash", this.newHash);
      if (this.isLoggedIn) {
        this.$store.dispatch("logoutRequest").then(() => {
          this.$router.push({ path: "/login" });
        });
      }
      window.location.reload();
    }
  }
};
